import { Plus } from "lucide-react";
import { Reveal } from "@/components/motion/motion";
import { useI18n } from "@/lib/i18n/use-i18n";
import { displayH2, Overline } from "./SectionHeading";

type FaqItems = Record<string, { question: string; answer: string }>;

/** Native `<details>` FAQ: works without JS and matches the visible copy. */
export function Faq({ title, items }: { title: string; items: FaqItems }) {
	const { t } = useI18n();

	return (
		<div className="grid gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-20">
			<Reveal className="space-y-5 lg:sticky lg:top-28 lg:self-start">
				<Overline>{t((t) => t.common.faqLabel)}</Overline>
				<h2 className={displayH2}>{title}</h2>
			</Reveal>
			<Reveal className="border-t">
				{Object.entries(items).map(([key, item]) => (
					<details key={key} className="group border-b">
						<summary className="flex cursor-pointer list-none items-start justify-between gap-6 rounded-md py-6 text-lg font-medium outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 [&::-webkit-details-marker]:hidden">
							<span className="text-pretty">{item.question}</span>
							<span
								aria-hidden="true"
								className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full border transition-[transform,background-color,border-color] duration-300 ease-(--ease-soft) group-open:rotate-45 group-open:border-signal group-open:bg-signal group-open:text-signal-foreground"
							>
								<Plus className="size-3.5" />
							</span>
						</summary>
						<p className="max-w-2xl pr-12 pb-6 text-pretty text-muted-foreground">
							{item.answer}
						</p>
					</details>
				))}
			</Reveal>
		</div>
	);
}
